import { useState, useEffect } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import Diversity2Icon from "@mui/icons-material/Diversity2";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Unstable_Grid2";
import FaceIcon from "@mui/icons-material/Face";
import Chip from "@mui/material/Chip";
import ShowLoginInfo from "./ShowLoginInfo";
import ChangePhoneNumber from "./ChangePhoneNumber";
import EditUserName from "./EditUserName";
import SetGmail from "./SetGmail";
import ChangePassword from "./ChangePassword";
import SetRegisterCode from "./SetRegisterCode";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import AppSettingsAltIcon from "@mui/icons-material/AppSettingsAlt";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import PasswordIcon from "@mui/icons-material/Password";
import Tooltip from "@mui/material/Tooltip";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  getAuthUserinfoApi,
  ChangeUserNameApi,
  checkUsernameValidApi,
  changePasswordApi,
} from "../../../../../services/authApi";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../../../utils/utilsFunctions";
function LoginInfo(props) {
  const [editLoginInfo, setEditLoginInfo] = useState("ShowLoginInfo");
  const [authUserinfo, setAuthUserinfo] = useState({
    phoneNumber: "llmmt-Loading",
    userName: "llmmt-Loading",
    type_user: "llmmt-Loading",
    presenterCode: "llmmt-Loading",
    registerCode: "llmmt-Loading",
  });
  useEffect(() => {
    getAuthUserinfo();
  }, []);

  const createCustomData = (keys, value) => {
    const data = {};
    for (const key of keys) {
      data[key] = value;
    }
    return data;
  };
  const handleEditLoginInfo = (e) => {
    setEditLoginInfo(e.currentTarget.value);
  };
  const detectSize600px = useMediaQuery("(min-width:600px)");

  const getAuthUserinfo = async () => {
    try {
      const data = {};
      const response = await getAuthUserinfoApi(data);
      const customData = createCustomData(
        [
          "phoneNumber",
          "userName",
          "type_user",
          "presenterCode",
          "registerCode",
        ],
        "llmmt-NoData"
      );
      const resData = checkResponseData(response);
      if (resData["success"]) {
        setAuthUserinfo({
          ...authUserinfo,
          ...resData["data"]["data"][0],
        });
      } else {
        setAuthUserinfo({ ...authUserinfo, ...customData });
        customToastify("info", resData["message"]);
      }
    } catch (error) {
      const customData = createCustomData(
        [
          "phoneNumber",
          "userName",
          "type_user",
          "presenterCode",
          "registerCode",
        ],
        "llmmt-errorLoading"
      );
      setAuthUserinfo({ ...authUserinfo, ...customData });
      const errData = checkErrorMessage(error);
      customToastify("error", errData["titles"] || errData["message"]);
      console.error(error);
    }
  };

  const checkUsernameValid = async (data) => {
    const toastMsg = toast.loading("لطفا صبر کنید...")

    try {
      const response = await checkUsernameValidApi(data)
      const resData = checkResponseData(response);
      if (resData["success"]) {
        toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
      } else {
        toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
      console.error(error);
    }
  };

  const changeUserName = async (data) => {
    const toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      const response = await ChangeUserNameApi(data)
      const resData = checkResponseData(response);
      if (resData["success"]) {
        toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        if (resData["data"]["data"]) {
          setAuthUserinfo(resData["data"]["data"][0]);
        } else {
          // setUserInfo({ ...userinfo, ...customData });
          customToastify("info", resData["message"]);
        }
      } else {
        toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
      console.error(error);
    }
  };
  const changePassword = async (data) => {
    const toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      const response = await changePasswordApi(data)
      const resData = checkResponseData(response);
      if (resData["success"]) {
        toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        if (resData["data"]["data"].length > 0) {
          setAuthUserinfo(resData["data"]["data"][0]);
        }
        //  else {
        //   customToastify("info", resData["message"]);
        // }
      } else {
        toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
      }
    } catch (error) {
      console.error(error);
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
    }
  };

  const LoginInfoContent = (selected) => {
    switch (selected) {
      case "ShowLoginInfo":
        return (
          <ShowLoginInfo
            getAuthUserinfo={getAuthUserinfo}
            authUserinfo={authUserinfo}
          />
        );
      case "EditUserName":
        return (
          <EditUserName
            authUserinfo={authUserinfo}
            changeUserName={changeUserName}
            checkUsernameValid={checkUsernameValid}
          />
        );
      case "ChangePhoneNumber":
        return <ChangePhoneNumber authUserinfo={authUserinfo} />;
      case "ChangePassword":
        return <ChangePassword changePassword={changePassword} />;
      case "SetRegisterCode":
        return <SetRegisterCode authUserinfo={authUserinfo} />;
      case "SetEmail":
        return <SetGmail authUserinfo={authUserinfo} />;
      default:
        return "<ChangePhoneNumber />";
    }
  };

  return (
    <Grid container sx={{ height: "100vh" }}>
      <Box sx={{ width: "100%", px: 1 }}>
        <Tooltip title="نمایش اطلاعات ورود" arrow>
          <Button
            value="ShowLoginInfo"
            onClick={handleEditLoginInfo}
            sx={{ mt: 1 }}
          >
            <Chip
              clickable
              color={editLoginInfo == "ShowLoginInfo" ? "success" : "warning"}
              icon={<FaceIcon />}
              label={detectSize600px ? "نمایش اطلاعات ورود" : ""}
            />
          </Button>
        </Tooltip>
        <Tooltip title="تغییر نام کاربری" arrow>
          <Button
            value="EditUserName"
            onClick={handleEditLoginInfo}
            sx={{ mt: 1 }}
          >
            <Chip
              clickable
              color={editLoginInfo == "EditUserName" ? "error" : "warning"}
              icon={<ManageAccountsIcon />}
              label={detectSize600px ? "تغییر نام کاربری" : ""}
            />
          </Button>
        </Tooltip>
        <Tooltip title="ثبت شماره همراه" arrow>
          <Button
            value="ChangePhoneNumber"
            onClick={handleEditLoginInfo}
            sx={{ mt: 1 }}
          >
            <Chip
              clickable
              color={editLoginInfo == "ChangePhoneNumber" ? "error" : "warning"}
              icon={<AppSettingsAltIcon />}
              label={detectSize600px ? "ثبت شماره همراه" : ""}
            />
          </Button>
        </Tooltip>
        <Tooltip title="مدیریت کلمه عبور" arrow>
          <Button
            value="ChangePassword"
            onClick={handleEditLoginInfo}
            sx={{ mt: 1 }}
          >
            <Chip
              clickable
              color={editLoginInfo == "ChangePassword" ? "error" : "warning"}
              icon={<PasswordIcon />}
              label={detectSize600px ? "مدیریت کلمه عبور" : ""}
            />
          </Button>
        </Tooltip>
        <Tooltip title="ورود با ایمیل" arrow>
          <Button value="SetEmail" onClick={handleEditLoginInfo} sx={{ mt: 1 }}>
            <Chip
              clickable
              color={editLoginInfo == "SetEmail" ? "error" : "warning"}
              icon={<AlternateEmailIcon />}
              label={detectSize600px ? "ورود با ایمیل" : ""}
            />
          </Button>
        </Tooltip>
        <Tooltip title="ثبت کد های معرف" arrow>
          <Button
            value="SetRegisterCode"
            onClick={handleEditLoginInfo}
            sx={{ mt: 1 }}
          >
            <Chip
              clickable
              color={editLoginInfo == "SetRegisterCode" ? "error" : "warning"}
              icon={<Diversity2Icon />}
              label={detectSize600px ? "ثبت کد معرف" : ""}
            />
          </Button>
        </Tooltip>
        <hr />
        {LoginInfoContent(editLoginInfo)}
      </Box>
      {/* <ToastContainer
        position="bottom-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      /> */}
    </Grid>
  );
}

export default LoginInfo;
